package com.patronat.top.ui.organisms.user

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.molecules.StatusDropdown
import com.patronat.top.ui.molecules.UiStatusItem
import com.patronat.top.ui.molecules.avatar.EditableAvatar
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.*

@Composable
fun <T> UserFormContent(
    isCreatedUser: Boolean,
    title: String,
    state: UserFormData,
    statusOptions: List<UiStatusItem<T>>,
    onFieldChange: (UserFormData) -> Unit,
    onStatusChange: (T) -> Unit,
    onAvatarClick: () -> Unit,
    onSaveClick: () -> Unit,
    onCancelClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, RoundedCornerShape(12.dp))
            .padding(24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // --- HEADER ---
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = title,
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold,
                color = MineShaft950
            )
            IconButton(onClick = onCancelClick) {
                Icon(
                    painter = AppIcons.Close,
                    contentDescription = "Close",
                    tint = MineShaft500
                )
            }
        }

        HorizontalDivider(
            modifier = Modifier.padding(top = 16.dp, bottom = 24.dp),
            color = MineShaft100
        )

        // --- SCROLLABLE CONTENT ---
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f, fill = false)
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            // 1. Avatar
            EditableAvatar(
                imageUrl = state.avatarUrl,
                initials = state.initials,
                onClick = onAvatarClick,
                size = 100.dp
            )

            Spacer(modifier = Modifier.height(16.dp))


            @Suppress("UNCHECKED_CAST")
            StatusDropdown(
                items = statusOptions,
                selectedItem = state.statusItem as UiStatusItem<T>,
                onItemSelected = onStatusChange
            )

            Spacer(modifier = Modifier.height(24.dp))

            // 3. Inputs
            AppInput(
                label = "Ім’я",
                value = state.firstName,
                onValueChange = { onFieldChange(state.copy(firstName = it)) },
                placeholder = "Василь",
                leadingIcon = AppIcons.Profile
            )

            Spacer(modifier = Modifier.height(16.dp))

            AppInput(
                label = "Прізвище*",
                value = state.lastName,
                onValueChange = { onFieldChange(state.copy(lastName = it)) },
                placeholder = "Стус",
                leadingIcon = AppIcons.Profile
            )

            Spacer(modifier = Modifier.height(16.dp))

            AppInput(
                label = "Email*",
                value = state.email,
                onValueChange = { onFieldChange(state.copy(email = it)) },
                placeholder = "youremail@gmail.com",
                leadingIcon = AppIcons.Email,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email)
            )

            Spacer(modifier = Modifier.height(16.dp))

            AppInput(
                label = "Номер телефону*",
                value = state.phone,
                onValueChange = { onFieldChange(state.copy(phone = it)) },
                placeholder = "+3 800 000 000",
                inputMode = AppInputMode.Phone,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone)
            )

            Spacer(modifier = Modifier.height(32.dp))
        }

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.End,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = "Скасувати",
                color = MineShaft500,
                fontWeight = FontWeight.Medium,
                fontSize = 16.sp,
                modifier = Modifier
                    .clickable(onClick = onCancelClick)
                    .padding(horizontal = 16.dp, vertical = 8.dp)
            )

            Spacer(modifier = Modifier.width(16.dp))


            AppButton(
                text = if (isCreatedUser) "Додати" else "Зберегти зміни",
                onClick = onSaveClick,
                type = ButtonType.BrownFilled,
                enabled = state.isValid,
                isLoading = state.isLoading,
                leadingIcon = if (isCreatedUser) AppIcons.Plus else AppIcons.Check
            )
        }
    }
}
